import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ed23f1c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed23f1c')) {
      api.createRecord('3ed23f1c', component.options)
    } else {
      api.reload('3ed23f1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ed23f1c&", function () {
      api.rerender('3ed23f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/content-manage/recommender-code/index.vue"
export default component.exports